import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ClubPopupComponent } from './components/club-popup/club-popup.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CardModule } from 'primeng/card';
import { MatSelectModule } from '@angular/material/select';
import { LeaguePopupComponent } from './components/league-popup/league-popup.component';
import { CourtPopupComponent } from './components/court-popup/court-popup.component';
import { PhoneNumberPipe } from './Pipes/phone-number.pipe';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { UpdateProfileComponent } from './components/update-profile/update-profile.component';
import { QRPopupComponent } from './components/qr-popup/qr-popup.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

@NgModule({
    declarations: [ClubPopupComponent, QRPopupComponent, LeaguePopupComponent, CourtPopupComponent, PhoneNumberPipe, UpdateProfileComponent, BreadcrumbComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatFormFieldModule,
        MatDialogModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        MatTabsModule,
        CardModule,
        MatDatepickerModule,
        MatRadioModule,
        MatNativeDateModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [ClubPopupComponent, QRPopupComponent, CourtPopupComponent, PhoneNumberPipe, BreadcrumbComponent]
})
export class SharedModule { }
